module.exports = __webpack_public_path__ + "static/media/empty-cart.ceb2faf0.png";